import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function ManagementConsultingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/09e0f3731dd584e53c78eb9af8562a55.jpg"
            alt="Management Consulting"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative max-w-[1400px] mx-auto px-8 w-full text-center">
          <h1 className="text-8xl font-bold text-white mb-8 leading-tight">
            Глобальный подход<br />к управлению
          </h1>
          <p className="text-2xl text-[#D4AF37] font-light mb-12">
            Мы говорим на языке вашего бизнеса
          </p>
          <div className="flex items-center justify-center gap-6 mb-12">
            {['🇷🇺', '🇬🇧', '🇹🇷', '🇸🇦', '🇨🇳'].map((flag, i) => (
              <div key={i} className="text-5xl">{flag}</div>
            ))}
          </div>
          <Link to="/contacts" className="inline-flex items-center gap-3 px-14 py-6 rounded-full bg-white text-[#0A1628] font-semibold text-lg whitespace-nowrap hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer">
            Запросить стратегическую сессию
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-32 bg-[#F5F7FA]">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-semibold text-[#0A1628] mb-6">Наши услуги</h2>
            <p className="text-xl text-gray-600 font-light">Комплексные решения для вашего бизнеса</p>
          </div>

          <div className="grid grid-cols-2 gap-10">
            {[
              {
                gradient: 'from-[#0A1628] to-[#1B5E4F]',
                icon: 'ri-compass-3-line',
                title: 'Стратегическое планирование',
                description: 'Разработка долгосрочных стратегий роста',
                details: [
                  'Анализ текущего положения компании и конкурентной среды',
                  'Разработка стратегии выхода на новые рынки',
                  'Планирование масштабирования бизнеса',
                  'Создание дорожной карты развития на 3-5 лет',
                  'Определение ключевых показателей эффективности (KPI)'
                ]
              },
              {
                gradient: 'from-[#1B5E4F] to-[#2D8B6E]',
                icon: 'ri-settings-4-line',
                title: 'Оптимизация процессов',
                description: 'Повышение эффективности операций',
                details: [
                  'Аудит операционной деятельности и выявление узких мест',
                  'Внедрение lean-методологий и процессного управления',
                  'Автоматизация бизнес-процессов',
                  'Оптимизация затрат и повышение рентабельности',
                  'Разработка системы контроля качества'
                ]
              },
              {
                gradient: 'from-[#D4AF37] to-[#F4D03F]',
                icon: 'ri-bar-chart-box-line',
                title: 'Отраслевая экспертиза',
                description: 'Глубокий анализ рыночных ниш',
                details: [
                  'Исследование целевых рынков и отраслевых трендов',
                  'Анализ конкурентов и лучших практик',
                  'Оценка рисков и возможностей',
                  'Прогнозирование развития отрасли',
                  'Рекомендации по позиционированию'
                ]
              },
              {
                gradient: 'from-[#6B46C1] to-[#9333EA]',
                icon: 'ri-global-line',
                title: 'Выход на рынки',
                description: 'Международная экспансия',
                details: [
                  'Выбор оптимальных рынков для входа',
                  'Разработка стратегии локализации',
                  'Поиск партнеров и дистрибьюторов',
                  'Адаптация продукта под местные требования',
                  'Сопровождение на всех этапах выхода'
                ]
              }
            ].map((service, index) => (
              <div key={index} className="group relative h-[500px] rounded-[48px] overflow-hidden cursor-pointer perspective-1000">
                <div className="absolute inset-0 transition-transform duration-700 transform-style-3d group-hover:rotate-y-180">
                  {/* Front Side */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} p-12 flex flex-col justify-between backface-hidden`}>
                    <div>
                      <div className="w-32 h-32 rounded-full border-4 border-white/30 flex items-center justify-center mb-8">
                        <i className={`${service.icon} text-6xl text-white`}></i>
                      </div>
                      <h3 className="text-4xl font-semibold text-white mb-4">{service.title}</h3>
                      <p className="text-lg text-white/80 font-light">{service.description}</p>
                    </div>
                    <div className="text-white/60 text-sm font-light">Наведите для подробностей</div>
                  </div>

                  {/* Back Side */}
                  <div className="absolute inset-0 bg-white p-12 flex flex-col justify-between backface-hidden rotate-y-180">
                    <div>
                      <h3 className="text-3xl font-semibold text-[#0A1628] mb-8">{service.title}</h3>
                      <ul className="space-y-4">
                        {service.details.map((detail, i) => (
                          <li key={i} className="flex items-start gap-3">
                            <i className="ri-check-line text-[#D4AF37] text-xl mt-1 flex-shrink-0"></i>
                            <span className="text-gray-600 font-light leading-relaxed text-sm">{detail}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <button className="w-full py-4 rounded-full bg-[#0A1628] text-white font-medium whitespace-nowrap hover:bg-[#1B5E4F] transition-colors">
                      Узнать больше
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-2 gap-20 items-center">
            <div>
              <h2 className="text-6xl font-bold text-[#0A1628] mb-8 leading-tight">
                Почему выбирают нас
              </h2>
              <div className="space-y-8">
                {[
                  {
                    icon: 'ri-team-line',
                    title: 'Международная команда',
                    description: 'Эксперты с опытом работы в Fortune 500 компаниях и Big 4'
                  },
                  {
                    icon: 'ri-translate-2',
                    title: 'Без языковых барьеров',
                    description: 'Работаем на русском, английском, турецком, арабском и китайском'
                  },
                  {
                    icon: 'ri-lightbulb-line',
                    title: 'Инновационный подход',
                    description: 'Используем передовые методологии и лучшие мировые практики'
                  },
                  {
                    icon: 'ri-hand-heart-line',
                    title: 'Персональный подход',
                    description: 'Каждое решение адаптировано под специфику вашего бизнеса'
                  }
                ].map((item, i) => (
                  <div key={i} className="flex gap-6">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#1B5E4F] flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-2xl text-white`}></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-semibold text-[#0A1628] mb-2">{item.title}</h3>
                      <p className="text-gray-600 font-light leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Diverse%20international%20business%20team%20collaborating%20in%20modern%20office%2C%20professionals%20from%20different%20cultures%20working%20together%2C%20contemporary%20workspace%20with%20natural%20light%2C%20multicultural%20corporate%20environment%2C%20teamwork%20and%20collaboration%2C%20premium%20business%20photography%2C%20sophisticated%20atmosphere&width=800&height=1000&seq=team-collab&orientation=portrait"
                alt="International Team"
                className="w-full h-[700px] object-cover object-top rounded-[48px] shadow-[0_40px_100px_rgba(10,22,40,0.15)]"
              />
              <div className="absolute -bottom-10 -left-10 bg-white rounded-[32px] p-8 shadow-2xl">
                <div className="text-5xl font-bold text-[#D4AF37] mb-2">250+</div>
                <div className="text-gray-600 font-light">Успешных проектов</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-32 bg-[#F5F7FA]">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-semibold text-[#0A1628] mb-6">Как мы работаем</h2>
            <p className="text-xl text-gray-600 font-light">Прозрачный и эффективный процесс</p>
          </div>

          <div className="grid grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: 'Диагностика',
                description: 'Глубокий анализ текущей ситуации и выявление точек роста'
              },
              {
                step: '02',
                title: 'Стратегия',
                description: 'Разработка индивидуального плана действий с четкими KPI'
              },
              {
                step: '03',
                title: 'Реализация',
                description: 'Внедрение решений с постоянным контролем и корректировкой'
              },
              {
                step: '04',
                title: 'Результат',
                description: 'Достижение целей и масштабирование успешных практик'
              }
            ].map((item, i) => (
              <div key={i} className="relative">
                <div className="bg-white rounded-[40px] p-8 shadow-[0_20px_60px_rgba(10,22,40,0.08)] hover:shadow-[0_30px_80px_rgba(10,22,40,0.12)] transition-all hover:-translate-y-2">
                  <div className="text-7xl font-bold text-[#D4AF37]/20 mb-4">{item.step}</div>
                  <h3 className="text-2xl font-semibold text-[#0A1628] mb-4">{item.title}</h3>
                  <p className="text-gray-600 font-light leading-relaxed">{item.description}</p>
                </div>
                {i < 3 && (
                  <div className="absolute top-1/2 -right-4 w-8 h-0.5 bg-[#D4AF37] hidden xl:block"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-semibold text-[#0A1628] mb-6">Кейсы</h2>
            <p className="text-xl text-gray-600 font-light">Реальные результаты наших клиентов</p>
          </div>

          <div className="grid grid-cols-3 gap-8">
            {[
              {
                industry: 'E-commerce',
                result: '+340%',
                metric: 'рост выручки',
                description: 'Масштабирование онлайн-ритейлера на 5 новых рынков за 18 месяцев'
              },
              {
                industry: 'Производство',
                result: '-45%',
                metric: 'снижение затрат',
                description: 'Оптимизация производственных процессов и внедрение lean-методологий'
              },
              {
                industry: 'Финтех',
                result: '12 мес',
                metric: 'до прибыльности',
                description: 'Стратегическое планирование и выход на операционную прибыль'
              }
            ].map((item, i) => (
              <div key={i} className="bg-gradient-to-br from-[#F5F7FA] to-white rounded-[40px] p-10 border border-gray-200 hover:border-[#D4AF37] transition-all hover:-translate-y-2">
                <div className="text-sm text-[#D4AF37] font-medium mb-4 uppercase tracking-wider">{item.industry}</div>
                <div className="text-6xl font-bold text-[#0A1628] mb-2">{item.result}</div>
                <div className="text-lg text-gray-600 font-light mb-6">{item.metric}</div>
                <p className="text-gray-600 font-light leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-[#0A1628] to-[#1B5E4F] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-[100px]"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-[100px]"></div>
        </div>
        <div className="max-w-[1400px] mx-auto px-8 text-center relative">
          <h2 className="text-5xl font-bold text-white mb-6">Готовы к трансформации?</h2>
          <p className="text-xl text-gray-300 font-light mb-10">
            Запишитесь на бесплатную стратегическую сессию с нашими экспертами
          </p>
          <Link to="/contacts" className="inline-flex items-center gap-3 px-12 py-5 rounded-full bg-[#D4AF37] text-[#0A1628] font-semibold text-lg whitespace-nowrap hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer">
            Записаться на сессию
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />

      <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
        .group:hover .group-hover\\:rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>
    </div>
  );
}
